export const sendModalFormRules = {
  id: [{ required: true, message: window.$t('stores::order::ship_select_fulfilment'), trigger: 'change' }],
  number: [{ required: true, message: window.$t('stores::order::ship_input_fulfilment'), trigger: 'blur' }],
  // link: [{ required: true, message: '请输入物流跟踪链接', trigger: 'blur' }],
  time: [{ required: true, message: window.$t('stores::order::ship_select_deliver_time'), trigger: 'blur' }]
}

export const isSendModalColumns = [
  {
    prop: 'title',
    label: window.$t('stores::products-info::goods_info'),
    minWidth: 300
  },
  {
    prop: 'weight',
    label: window.$t('stores::products-info::weight'),
    minWidth: 120
  },
  {
    prop: 'quantity',
    label: window.$t('stores::order::ship_quantity'),
    width: 100
  }
]

export const deliveryColumns = [
  {
    prop: 'cname',
    label: window.$t('stores::order::shipping_way'),
    width: 200
  },
  {
    prop: 'shippingFee',
    label: window.$t('stores::order::shipping_fee')
  },
  {
    prop: 'otherFee',
    label: window.$t('stores::order::other_fee')
  },
  {
    prop: 'totalFee',
    label: window.$t('stores::order::all_fee')
  },
  {
    prop: 'deliveryDays',
    label: window.$t('stores::order::all_time')
  },
  {
    prop: 'selection',
    label: '',
    width: 85
  }
]
